// import "../../../sass/components/pre_login/_login.scss";
import OTPModal from "../../common/OTPModal";
import Login from "./login";
import Selfservice from "./self";
import Newpassword from "./newpassword";
import ResetPassword from "./recoverpassword";
import Success from "../sucess";
import RecoverPassword from "../RecoverPassword"
import React, {useContext, useState} from "react";
import { useNavigate } from "react-router-dom";
import Loader from "../../common/Loader";
import {ThemeContext} from "../../../styles/ThemeContext";

const LoginComponent = () => {
    const [step, setStep] = useState("login");


    const [userName, setUsername] = useState();
    const [passWord, setPassword] = useState();
    const { theme } = useContext(ThemeContext);
    const [modalVisible, setModalVisible] = useState(false)
    const [page, setPage] = useState("login")
    const [successVisible, setSuccessVisible] = useState(false);
    const [validationDetails, setValidationDetails] = useState({})
    const [userCredentials, setUserCredentials] = useState({})
    const [message, setMessage] = useState("Your new password has been set successfully")
    const [usrprop, serUserNameProp] = useState();
    const navigate = useNavigate()
    const [loader, showLoader] = useState(false)

    const goToHome = () => {
        navigate("/")
    }

    const goToLogin = () => {
        if (Object.keys(userCredentials).length > 0) {
            navigate("/")
            return
        }
        setPage("login")
        setSuccessVisible(false)
    }
   console.log("test", theme)
    return (

        <div className="login-split-layout">
            
            <Loader loader={loader} />
           
            
            {successVisible && <Success message={message} userCredentials={userCredentials} action={goToLogin} />}

            {modalVisible && <OTPModal userCredentials={userCredentials} setValidationDetails={setValidationDetails} validationDetails={validationDetails} userName={userName} modalVisible={modalVisible} setModalVisible={setModalVisible} action={goToHome} setPage={setPage} passWord={passWord} />}


            <div className="splitdiv" id="leftdiv" style={{backgroundImage: `url(${require(`../../../assets/${theme.images.loginImage}`)})`}}
            >
                <div className="image-holder"></div>
                <div id="leftdivcard">
                    <div className="logo-holder"><div className="coop-logo"></div></div>

                    <div className="card-row">

                        <h1></h1>
                        <p ></p>
                        <div className="captions-text">
                            {/*Contributing to the reduction of rural poverty and food insecurity of smallholders in the ASALs by developing their economic potential*/}
                        </div>
                    </div>

                </div>
            </div>

            <div className="splitdiv" id="rightdiv">
                <div id="rightdivcard" className="login-card">
                    
                    <div className="svg-backgound"></div>

                    {page === "login" && <Login setUserCredentials={setUserCredentials} setValidationDetails={setValidationDetails} userName={userName} setUsername={setUsername} passWord={passWord} setPassword={setPassword} modalVisible={modalVisible} setModalVisible={setModalVisible} setPage={setPage} showLoader={showLoader} />}
                    {page === "self" && <Selfservice setMessage={setMessage} setPage={setPage} setSuccessVisible={setSuccessVisible} serUserNameProp={serUserNameProp} showLoader={showLoader}/>}
                    {page === "password" && <Newpassword  userName={userName} setPage={setPage} setSuccessVisible={setSuccessVisible}  setUserCredentials={setUserCredentials} setValidationDetails={setValidationDetails} showLoader={showLoader} />}
                    {page === "recover" && <RecoverPassword isVerified={true} setPage={setPage} setSuccessVisible={setSuccessVisible} setUserCredentials={setUserCredentials}  userName={usrprop} />}
                    {page === "reset" && <ResetPassword isVerified={true} setPage={setPage} setSuccessVisible={setSuccessVisible} setUserCredentials={setUserCredentials}  userName={usrprop} />}

                </div>
            </div>

        </div>
    );
}

export default LoginComponent;
